<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import { XMarkIcon } from '@heroicons/vue/24/outline';

defineEmits<{ dismiss: [] }>();

const route = useRoute();
const router = useRouter();

function signIn() {
  router.push({ path: '/auth/redirect', query: { returnTo: route.fullPath } });
}
</script>

<template>
  <div
    data-test="banner-signed-out-elsewhere"
    class="relative z-[60] flex items-center justify-between gap-3 border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-800"
  >
    <span>You've been signed out. Sign in again whenever you're ready.</span>
    <div class="flex flex-none items-center gap-3">
      <button
        type="button"
        data-test="btn-banner-sign-in"
        class="font-semibold underline"
        @click="signIn"
      >
        Sign in
      </button>
      <button
        type="button"
        data-test="btn-banner-dismiss"
        aria-label="Dismiss"
        @click="$emit('dismiss')"
      >
        <XMarkIcon class="size-4" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>
